/**
 * RoPro - Enhance Your Roblox Experience
 *
 * Roblox enhancer; resources scoped to roblox.com.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 1.7.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'adbacgifemdbhdkfppmeilbgppmhaobf';
export const ropro: ExtensionDefinition = {
  id: ID,
  name: "RoPro - Enhance Your Roblox Experience",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  requiredOrigin: 'https://www.roblox.com',
  notes: "Roblox enhancer; resources scoped to roblox.com.",
  signals: [
    { id: 'war-js-page-fetchangular-js', kind: 'web-accessible-resource',
      description: 'Fetch js/page/fetchAngular.js, exposed only to https://www.roblox.com.',
      weight: 1, run: () => probeFetch(ID, 'js/page/fetchAngular.js') },
    { id: 'war-js-page-fetchservers-js', kind: 'web-accessible-resource',
      description: 'Fetch js/page/fetchServers.js, exposed only to https://www.roblox.com.',
      weight: 0.5, run: () => probeFetch(ID, 'js/page/fetchServers.js') },
  ],
};
